import apiClient from './apiClient'

export const getCoupons = async (params = {}) => {
  const response = await apiClient.get('/marketing/coupons/', { params })
  return response.data
}

export const createCoupon = async (data) => {
  const response = await apiClient.post('/marketing/coupons/', data)
  return response.data
}

export const updateCoupon = async (id, data) => {
  const response = await apiClient.patch(`/marketing/coupons/${id}/`, data)
  return response.data
}

export const deleteCoupon = async (id) => {
  await apiClient.delete(`/marketing/coupons/${id}/`)
}

export const validateCoupon = async (code, purchaseAmount = 0) => {
  const response = await apiClient.post('/marketing/coupons/validate/', {
    code: code.trim(),
    purchase_amount: purchaseAmount,
  })
  return response.data
}

export const normalizeCouponForCart = (payload) => {
  const coupon = payload?.coupon || payload
  if (!coupon?.code) return null
  return {
    id: coupon.id,
    code: coupon.code,
    type: coupon.type,
    value: Number(coupon.value),
    min_purchase: coupon.min_purchase,
    max_amount: Number(coupon.max_amount) || 0,
    discount_percentage: coupon.type === 'percentage' ? Number(coupon.value) : 0,
    discount_amount: coupon.type === 'fixed' ? Number(coupon.value) : 0,
    free_shipping: coupon.type === 'free_shipping',
  }
}

export const getFreeShippingPromotions = async () => {
  const response = await apiClient.get('/marketing/free-shipping-promotions/')
  return response.data
}

export const createFreeShippingPromotion = async (data) => {
  const response = await apiClient.post('/marketing/free-shipping-promotions/', data)
  return response.data
}

export const updateFreeShippingPromotion = async (id, data) => {
  const response = await apiClient.patch(`/marketing/free-shipping-promotions/${id}/`, data)
  return response.data
}

export const deleteFreeShippingPromotion = async (id) => {
  await apiClient.delete(`/marketing/free-shipping-promotions/${id}/`)
}

export const getMyFreeShippingPromotions = async () => {
  const response = await apiClient.get('/marketing/free-shipping-promotions/mine/')
  return response.data
}

export const checkFreeShipping = async (subtotal, couponId = null) => {
  const response = await apiClient.post('/marketing/free-shipping-promotions/check/', {
    subtotal,
    coupon_id: couponId,
  })
  return response.data
}

export const getOffers = async (params = {}) => {
  const response = await apiClient.get('/marketing/offers/', { params })
  return response.data
}

/** Mejor oferta activa aplicable al rol del usuario (banner de tienda). */
export const getMyActiveOffer = async () => {
  const response = await apiClient.get('/marketing/offers/mine/')
  return response.data
}

export const createOffer = async (data) => {
  const response = await apiClient.post('/marketing/offers/', data)
  return response.data
}

export const updateOffer = async (id, data) => {
  const response = await apiClient.patch(`/marketing/offers/${id}/`, data)
  return response.data
}

export const deleteOffer = async (id) => {
  await apiClient.delete(`/marketing/offers/${id}/`)
}
